import { createSvgIcon } from 'netline-ui';

const Compact = createSvgIcon(
  <g stroke="none" strokeWidth="1">
    <g id="compact_favicon" transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ">
      <path
        d="M14,10 L2,10 L2,12 L14,12 L14,10 Z M14,6 L2,6 L2,8 L14,8 L14,6 Z M2,16 L10,16 L10,14 L2,14 L2,16 Z"
        fill="#757575"
      />
      <path
        d="M22,17.2904615 L22,16.2436923 L17.7894737,13.6267692 L17.7894737,10.7481538 C17.7894737,10.3137446 17.4368421,9.96307692 17,9.96307692 C16.5631579,9.96307692 16.2105263,10.3137446 16.2105263,10.7481538 L16.2105263,13.6267692 L12,16.2436923 L12,17.2904615 L16.2105263,15.982 L16.2105263,18.8606154 L15.1578947,19.6456923 L15.1578947,20.4307692 L17,19.9073846 L18.8421053,20.4307692 L18.8421053,19.6456923 L17.7894737,18.8606154 L17.7894737,15.982 L22,17.2904615 Z"
        fill="#757575"
      />
    </g>
  </g>,
  'Compact',
);

export default Compact;
